import { BtvMediaState } from './types';

export const initialState: BtvMediaState = {
  btvMedia: null,
  loadingBtvMedia: false,
};
